<div class="content-wrapper-inner relative">
  <app-users-form (onAfterSave)="afterSave()"></app-users-form>
</div>
